import React from 'react';

interface CardContainerProps {
  children: React.ReactNode;
  onClick?: () => void;
  isClickable?: boolean;
  opacity?: number;
  style?: React.CSSProperties;
}

export const CardContainer: React.FC<CardContainerProps> = ({
  children,
  onClick,
  isClickable = false,
  opacity = 1,
  style = {},
}) => {
  return (
    <div
      style={{
        backgroundColor: '#fff',
        borderRadius: '14px',
        padding: '16px',
        marginBottom: '16px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        position: 'relative',
        cursor: isClickable ? 'pointer' : 'default',
        opacity,
        ...style,
      }}
      onClick={isClickable ? onClick : undefined}
    >
      {children}
    </div>
  );
};
